<template>
  <div class="base">
    <inside-header color="grey" title="我的账户" />
    <div class="main">
      <div class="withdrawal-panel">
        <div class="title">
          <span class="icon">
            <van-icon name="alipay" />
          </span>
          <span class="label">提现到支付宝（{{ auth_real_name }}）</span>
        </div>
        <div class="input-alipay-account">
          <a-input v-model="alipay_account" placeholder="请输入支付宝账号/手机号/邮箱" />
        </div>
      </div>
    </div>
    <div class="withdrawal-area">
      <div class="title">
        <span>提现金额</span>
        <span>
          <a-tooltip placement="bottom" style="cursor: pointer;">
            <template slot="title">
              <span>当前推广收益为{{ undrawn_income }}元，支持10的倍数进行提现</span>
            </template>
            <span>&nbsp;&nbsp;
              <a-icon style="color: #999;" type="question-circle" />
            </span>
          </a-tooltip>
        </span>
      </div>
      <div class="total">
        <!-- <span class="prefix">￥</span>
        <span class="money">99.00</span> -->
        <a-input-number v-model="withdrawal_amount" :min="0"
          :max="100 > withdrawable_income ? withdrawable_income : 100" :step="10" style="width: 100%" size="large" />
      </div>
      <div class="show">
        <span class="cash">
          当前资产为{{ undrawn_income }}元，可提现金额{{ withdrawable_income }}元，
        </span>
        <span class="all-cash" @click="withdrawalFull">
          全部提现
        </span>
      </div>
      <div class="btn-area">
        <a-button block type="primary" :loading="state.withdrawalBtn" :disabled="withdrawable_income < 10"
          @click="withdrawalBegins">
          立即提现
        </a-button>
      </div>
    </div>
  </div>
</template>
<script>
import { InsideHeader } from '@/components'

export default {
  name: 'UserPromoteWithDrawal',
  components: {
    InsideHeader
  },
  data() {
    return {
      loading: true,
      state: {
        withdrawalBtn: false
      },
      auth_real_name: '',
      undrawn_income: 0,
      withdrawable_income: 0,
      // 提现金额
      alipay_account: '',
      withdrawal_amount: 0
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$http({
        url: 'index/teacher/withdrawnDetails',
        method: 'get'
      }).then(res => {
        this.loading = false
        console.log(res)
        if (res.status === 'success') {
          var data = res.data
          this.auth_real_name = data.auth_real_name
          this.undrawn_income = parseInt(data.undrawn_income)
          this.withdrawable_income = parseInt(data.withdrawable_income)
          console.log(data)
        }
      })
    },
    withdrawalFull() {
      this.withdrawal_amount = this.withdrawable_income
    },
    withdrawalBegins() {
      if (this.alipay_account === '') {
        this.$toast.fail('请输入支付宝账号')
        return false
      }

      if (this.withdrawal_amount === 0) {
        this.$toast.fail('请输入提现金额')
        return false
      }
      this.state.withdrawalBtn = true
      this.$http({
        url: 'index/teacher/withdrawnDetails',
        method: 'post',
        data: {
          alipay_account: this.alipay_account,
          withdrawal_amount: this.withdrawal_amount
        }
      }).then(res => {
        this.loading = false
        console.log(res)
        if (res.status === 'success') {
          this.$toast.success(res.message)
        } else {
          this.$toast.fail(res.message)
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;
    background-color: #f6f6f6;

    .withdrawal-panel {
      padding: 15px;
      height: 110px;
      background-color: #ffffff;
      border-radius: 10px;

      .title {
        line-height: 15px;

        .icon {
          color: #3773f1
          position: relative;
          top: 1px;
        }

        .label {
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          line-height: 14px;
          color: #333333;

          margin-left: 5px;
        }
      }

      .input-alipay-account {
        margin-top: 16px;

        input {
          width: 315px;
          height: 40px;
          border-radius: 10px;
        }
      }
    }
  }

  .withdrawal-area {
    padding: 30px;
    background-color: #fff;
    border-radius: 25px;

    .title {
      font-family: PingFang-SC-Medium;
      font-size: 14px;
      line-height: 19px;
      color: #333333;
    }

    .total {
      margin-top: 15px;
      padding-top: 15px;
      padding-bottom: 15px;

      .prefix {
        font-family: PingFang-SC-Medium;
        font-size: 18px;
        line-height: 19px;
        color: #333333;
      }

      .money {
        font-family: Bahnschrift;
        font-size: 36px;
        line-height: 14px;
        color: #333333;

        margin-left: 5px;
      }

      border-bottom: 1px solid #eee;
    }

    .show {
      margin-top: 15px;

      .cash {
        font-family: PingFang-SC-Regular;
        font-size: 12px;
        line-height: 19px;
        color: #666666;
      }

      .all-cash {
        font-family: PingFang-SC-Regular;
        font-size: 12px;
        color: #ff5c00;
      }
    }

    .btn-area {
      margin-top: 60px;

      button {
        height: 40px;
        border-radius: 10px;
      }
    }
  }
</style>
